import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { GetConsultationDocumentRequest } from 'api';
import { getConsultationDocument } from '../methods';
import { GetConsultationDocumentResponse } from '../types';

export const useConsultationDocument = (): UseMutationResult<
  GetConsultationDocumentResponse,
  unknown,
  GetConsultationDocumentRequest
> => useMutation(getConsultationDocument);
